"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FindPickupPoints = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _Loading = require("../Loading");
var _SearchField = require("./SearchField");
var _styles = require("./styles");
var _useFindPickupPoints = require("./useFindPickupPoints");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const componentName = 'FindPickupPoints.tsx';
const InstantResult = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./InstantResult'))));
const PickupPointsMap = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../Maps/PickupPointsMap'))));
const PickupPointsList = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./PickupPointsList'))));

/**
 * Older version of pickup points dialog. The last version is in `SelectPickupPointDialog.tsx`
 * and uses merged map & list view.
 * @obsolete Can be dropped later when flat selection UI is used in all markets
 * and/or the merged map & list UI switch is enabled everywhere.
 */
const FindPickupPoints = props => {
  const {
    getTestId,
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    handleBackClick,
    handleLayoutChange,
    instantResultProps,
    isInstantResultEnabled,
    isInstantResultOpened,
    isMapAvailable,
    isMapVisible,
    isMapLayoutShown,
    isPickupPointsListVisible,
    pickupPointsListProps,
    pickupPointsMapProps,
    pickupSearchConfiguration,
    searchFieldProps,
    searchFilterProps,
    selectedLayout,
    togglePickupPointsDialog
  } = (0, _useFindPickupPoints.useFindPickupPoints)(props);
  const ownerState = {
    isInstantResultOpened,
    isMapAvailable,
    isMapLayoutShown
  };
  const usedSearchFilterProps = {
    className: _styles.customFilterButtonClass,
    ...searchFilterProps,
    menuProps: {
      ...searchFilterProps.menuProps,
      ...getTestIdProps(_models.TestId.DeliveryFilterPopup)
    },
    ...getTestIdProps(_models.TestId.DeliveryFilter),
    label: formatMessage('filter')
  };
  (0, _logger.logDebug)(`Rendering ${componentName} ...\n\tprops:`, props, '\n\tlocal vars:', {
    instantResultProps,
    isInstantResultEnabled,
    isInstantResultOpened,
    isMapAvailable,
    isMapLayoutShown,
    isPickupPointsListVisible,
    pickupPointsListProps,
    pickupSearchConfiguration,
    searchFieldProps,
    selectedLayout,
    usedSearchFilterProps
  });
  const HeaderElement = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Header, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchWrapper, {
      ownerState: {
        isInstantResultOpened
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchField.SearchField, {
        ...searchFieldProps
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledFilterButton, {
        ...usedSearchFilterProps
      })]
    }), isMapAvailable && !isInstantResultOpened ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Tabs, {
      variant: "fullWidth",
      value: selectedLayout,
      onChange: handleLayoutChange,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LayoutTab, {
        value: _models.PickupPointsLayout.List,
        label: formatMessage('list'),
        "data-testid": getTestId(_models.TestId.PickupPointsListTab)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LayoutTab, {
        value: _models.PickupPointsLayout.Map,
        label: formatMessage('map'),
        "data-testid": getTestId(_models.TestId.PickupPointsMapTab)
      })]
    }) : null]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PickupPointsDialog, {
    hideBackdrop: true,
    hideCloseButton: true,
    open: true,
    showBackButton: true,
    size: "small",
    maxWidth: "700px",
    header: HeaderElement,
    "data-testid": getTestId(_models.TestId.FindPickupPointsDialog),
    onClose: togglePickupPointsDialog,
    onBack: handleBackClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PickupPointsDialogContent, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isInstantResultEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
            id: _models.TestId.DialogLoadingOverlayInstantResult
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(InstantResult, {
            ...instantResultProps
          })
        }) : null, isMapAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: isMapVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
            id: _models.TestId.DialogLoadingOverlayPickupPointsMap
          }) : undefined,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PickupPointsMap, {
            ...pickupPointsMapProps
          })
        }) : null, isPickupPointsListVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
            id: _models.TestId.DialogLoadingOverlayPickupPointsList
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PickupPointsList, {
            ...pickupPointsListProps
          })
        }) : null]
      })
    })
  });
};
exports.FindPickupPoints = FindPickupPoints;
var _default = exports.default = FindPickupPoints;